import { ConfigTypes } from '../constants/configConstants';

const changeLang = (lang) => ({
    type: ConfigTypes.LANG_CHANGE,
    lang, 
});

const jumpToTab = (tab) => ({
    type: ConfigTypes.JUMP_TO_TAB,
    tab, 
});

const viewChangelog = (view) => ({
    type: ConfigTypes.VIEW_CHANCELOG,
    view, 
});

const setTableId = (tableId) => ({
    type: ConfigTypes.SET_TABLE_ID,
    tableId, 
});

export default {
    changeLang,
    jumpToTab,
    viewChangelog,
    setTableId
};